<template>

    <div class="surface-ground px-4 py-5 md:px-6 lg:px-8">
        <div class="grid" v-if="this.$page.props.roles == 'administrator'">
            <div class="col-12 md:col-6 lg:col-3">
                <div class="surface-card shadow-2 p-3 border-round">
                    <div class="flex justify-content-between mb-3">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{ $t('candidate') }}</span>
                            <div class="text-900 font-medium text-xl">{{ this.$page.props.count_applicant }} {{ $t('people') }}</div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                            style="width:2.5rem;height:2.5rem">
                            <i class="pi pi-user-plus text-blue-500 text-xl"></i>
                        </div>
                    </div>
                    <!-- <span class="text-green-500 font-medium">24 new </span>
                    <span class="text-500">since yesterday</span> -->
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <div class="surface-card shadow-2 p-3 border-round">
                    <div class="flex justify-content-between mb-3">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{ $t('employee') }}</span>
                            <div class="text-900 font-medium text-xl">{{ this.$page.props.count_employee }} {{ $t('people') }}</div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-orange-100 border-round"
                            style="width:2.5rem;height:2.5rem">
                            <i class="pi pi-users text-orange-500 text-xl"></i>
                        </div>
                    </div>
                    <!-- <span class="text-green-500 font-medium">%52+ </span>
                    <span class="text-500">since last week</span> -->
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <div class="surface-card shadow-2 p-3 border-round">
                    <div class="flex justify-content-between mb-3">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{ $t('invoices') }}</span>
                            <div class="text-900 font-medium text-xl">{{ this.$page.props.count_invoice }}</div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-cyan-100 border-round"
                            style="width:2.5rem;height:2.5rem">
                            <i class="pi pi-inbox text-cyan-500 text-xl"></i>
                        </div>
                    </div>
                    <!-- <span class="text-green-500 font-medium">520 </span>
                    <span class="text-500">newly registered</span> -->
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <div class="surface-card shadow-2 p-3 border-round">
                    <div class="flex justify-content-between mb-3">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{ $t('letters') }}</span>
                            <div class="text-900 font-medium text-xl">{{ this.$page.props.count_employee }} {{ $t('unread') }}</div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-purple-100 border-round"
                            style="width:2.5rem;height:2.5rem">
                            <i class="pi pi-comment text-purple-500 text-xl"></i>
                        </div>
                    </div>
                    <!-- <span class="text-green-500 font-medium">85 </span>
                    <span class="text-500">responded</span> -->
                </div>
            </div>
        </div>
        <div class="grid" v-else>
            <div class="col-12">
                <div class="surface-card shadow-2 p-3 border-round">
                    <div class="flex flex-column align-items-center justify-content-center mb-3">
                        <img v-bind:src="'/images/logo-hris-website.png'" alt="Logo"/>
                        <h1 class="max-w-2xl mb-4 text-3xl font-extrabold">Selamat Datang Kembali, {{ this.$page.props.name }}</h1>
                        <p>Silahkan nikmati pengalaman dari penggunaan aplikasi kami</p>
                    </div>
                    <!-- <span class="text-green-500 font-medium">24 new </span>
                    <span class="text-500">since yesterday</span> -->
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'

export default {
    layout: AppLayout,
};
</script>
